import React from 'react';
import { Locales } from "../../helper/Locales.js";
import { Input } from "../input/Input.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const InputNumber = ({
  locale = 'de',
  format = {},
  ...props
}) => {
  const formatConfig = Locales[locale];
  const formatProp = {
    thousandSeparator: formatConfig.thousandSeparator,
    decimalSeparator: formatConfig.decimalSeparator,
    isNumericString: true,
    ...format
  };
  return /*#__PURE__*/_jsx(Input, {
    format: formatProp,
    ...props
  });
};